module.exports = __webpack_public_path__ + "static/img/hy04.be7a0fcd.png";